import { render, staticRenderFns } from "./OrcidPublicationsTable.vue?vue&type=template&id=4e5af7c2&scoped=true"
import script from "./OrcidPublicationsTable.vue?vue&type=script&lang=js"
export * from "./OrcidPublicationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5af7c2",
  null
  
)

export default component.exports